import React from 'react'
import loadable from '@loadable/component'

import buildLinkForButtons from '../../../utils/buildLinkForButtons'
// import AcfCtaBanner from '../AcfCtaBanner'

import AcfImageContent from '../AcfImageContent'
import AcfWysiwyg from '../AcfWysiwyg'

import * as style from './style.module.scss'

const InvoiceGenerator = loadable(() => import('../../InvoiceGenerator'))

const AcfBuilderParts = ({ acf, blockCount, data, preview }) => {
    const blockId = `acf-block-${blockCount}`

    const styleBuilderClass = [style.builder]

    // Clean up acf group name
    let crossPostFieldGroupName = acf.fieldGroupName

    crossPostFieldGroupName = crossPostFieldGroupName.split('_')
    const acfFieldItem = crossPostFieldGroupName.pop()

    if (acfFieldItem === 'ImageContent') {
        return (
            <section className={styleBuilderClass.join(' ')} id={blockId}>
                <AcfImageContent
                    altTag={acf.svgImage?.altText || ''}
                    buttonLink={buildLinkForButtons({
                        custom: acf.button.customUrl,
                        postType: acf.button.link && acf.button.link.postType,
                        slug: acf.button.link && acf.button.link.slug,
                        customUrl: acf.button.customLink,
                    })}
                    buttonText={acf.button.text}
                    content={acf.content}
                    contentPosition={acf.contentPosition}
                    heading={acf.heading}
                    headingTag={acf.headingTag}
                    imagePercent={
                        acf.svgImage &&
                        `${
                            (acf.svgImage.mediaDetails.height /
                                acf.svgImage.mediaDetails.width) *
                            100
                        }%`
                    }
                    svg={acf.svgImage?.localFile?.publicURL || ''}
                    titleTag={acf.svgImage?.title || ''}
                />
            </section>
        )
    }

    if (acfFieldItem === 'Wysiwyg') {
        return (
            <section className={styleBuilderClass.join(' ')} id={blockId}>
                <AcfWysiwyg content={acf.content} preview={preview} />
            </section>
        )
    }

    // if (
    //     acfFieldItem === 'CtaBanner'
    // ) {
    //     return (
    //         <section id={blockId}>
    //             <AcfCtaBanner
    //                 buttonLink={buildLinkForButtons({
    //                     custom: acf.button.customUrl,
    //                     postType: acf.button.link && acf.button.link.postType,
    //                     slug: acf.button.link && acf.button.link.slug,
    //                     customUrl: acf.button.customLink,
    //                 })}
    //                 buttonText={acf.button.text}
    //                 content={acf.content}
    //                 heading={acf.heading}
    //             />
    //         </section>
    //     )
    // }

    if (acfFieldItem === 'InvoiceBuilder') {
        return (
            <section className={style.gen} id={blockId}>
                <InvoiceGenerator />
            </section>
        )
    }

    return null
}

const AcfBuilder = ({ data, preview }) => {
    let blockCount = 0
    if (data && data.length > 0) {
        const components = data.map((acf) => {
            if (acf) {
                blockCount += 1

                return (
                    <AcfBuilderParts
                        key={`acf-block-${blockCount}`}
                        acf={acf}
                        blockCount={blockCount}
                        data={data}
                        preview={preview}
                    />
                )
            }
            return null
        })
        return components
    }
    return null
}

export default AcfBuilder
